/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, ReactNode, FC } from 'react';
import Popover from '@mui/material/Popover';
import { NewReleases } from '@mui/icons-material';
import { Badge, Divider, IconButton, Tooltip } from '@mui/material';
import { getUpload } from 'src/store/global.store';
import { useObservable } from 'src/framework/store/storeUtil';
import { IDataRequest, IDataResponse, apiNoLoading } from 'src/framework/providers/api';
import DialogCarrosselNotification from './DialogCarrosselNotification';
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { PermissionUtil } from 'src/framework/commons/PermissionUtil';
import { NotificacaoItem } from './NotifcacaoItem';
import { useTermosStore } from 'src/store/termos/termos.store';
import { LoginStore } from 'src/framework/store/LoginStore';
import { modelCodigoServicoOpen$ } from 'src/framework/store/ApiEvents';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export interface ElementoAtributos {
    image: string,
    titulo: string,
    subTitulo: string,
    descricao: string,
    linkSaibaMais: string,
    openDialog: boolean
    urlOndeExibir?: string,
    exibicao?: number,
    visualizado?: boolean,
}

export interface NotificacaoElemento {
    id: number,
    handleOpenDialog: Function,
    elementoAtributos: ElementoAtributos
}

export enum TipoExibicao {
    EXIBIR_SEMPRE = 1,
    EXIBIR_UMA_VEZ = 2,
}

interface INotificacoesLista {
    [url: string]: NotificacaoElemento[]
}

const Notifications: FC = () => {
    const permissoes = PermissionUtil.getPermissions();

    const modalCodigoServicoOpen = useObservable(modelCodigoServicoOpen$)
    const isLoggedIn = useObservable(LoginStore.isLoggedInSubject())
    // const upload: CacheType<IUploadConfig> | null = LocalStorage.get("solar.upload", true);
    const [distribuidorRevendaId, setDistribuidorRevendaId] = useState<number>(0);
    
    const [notificacoes, setNotificacoes] = useState<NotificacaoElemento[]>([]);
    const [notificacoesExibir, setNotificacoesExbir] = useState<NotificacaoElemento[]>([]);
    const [notificacoesUrl, setNotificacoesUrl] = useState<INotificacoesLista>({});
    const [visualizadoIds, setVisualizadoIds] = useState<number[]>([]);
    const { termosPendentes } = useTermosStore(store => store.state.data);

    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    
    const open = Boolean(anchorEl);

    const handleClickPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClosePopover = () => {
        setAnchorEl(null);
    };

    const handleOpenDialog = () => {
        
    };

    const handleCloseCarrosselDialog = async () => {
        setNotificacoesExbir([]);
    };

    const getPopups = useCallback(async (): Promise<IDataResponse> => {
        const request: IDataRequest = {
            url: 'cadastros/popups',
        }
        try {
            const response: IDataResponse = await apiNoLoading.get(request);
            return response;
        } catch (error) {
            return {
                data: [],
                message: error as any,
                statusCode: 204
            }
        }
    }, [distribuidorRevendaId]);

    const validaPopups = async () => {
        if (PermissionUtil.can(PermissionUtil.PERMISSION_POPUPS_LISTAGEM, permissoes || [])) {
            const notificacoes: NotificacaoElemento[] = [];
            const _notificacoesUrl: INotificacoesLista = {};
            await getUpload();
            const response = await getPopups()
            const _upload = LocalStorage.get("solar.uploadInfo", true);
            if (response?.data?.length) {
                for await (const popUp of response.data) {
                    const pathImage = popUp.url_upload.includes('http') ? ( "//" + popUp.url_upload) : popUp.url_upload?.trim() ?  ("//" + _upload?.data?.url + popUp.url_upload) : '';
                    const _notificacao = {
                        id: popUp.id,
                        handleOpenDialog: handleOpenDialog,
                        elementoAtributos: {
                            image: pathImage,
                            titulo: popUp.titulo,
                            subTitulo: getStringDate(popUp.created_at),
                            descricao: popUp.descricao,
                            urlOndeExibir: popUp.onde_exibir,
                            exibicao: popUp.exibicao,
                            linkSaibaMais: popUp.url,
                            openDialog: false,
                            visualizado: popUp.visualizado
                        }
                    }
                    notificacoes.push(_notificacao);

                    if ((popUp?.onde_exibir && (popUp?.exibicao === TipoExibicao.EXIBIR_SEMPRE)) || (TipoExibicao.EXIBIR_UMA_VEZ && popUp?.visualizado === false) ) {
                        const pathOndeExibir = popUp?.onde_exibir || window.location.origin;
                        if (!_notificacoesUrl[pathOndeExibir]) {
                            _notificacoesUrl[pathOndeExibir] = [];
                        }
                        _notificacoesUrl[pathOndeExibir].push(_notificacao);
                    }

                    if (popUp?.visualizado) {
                        setVisualizadoIds([...visualizadoIds, popUp.id]);
                    }
                }
                setNotificacoesUrl(_notificacoesUrl);
                setNotificacoes(notificacoes);
            }
            
        }
    }

    useEffect(() => {
        validaPopups()
    }, []);
    
    useEffect(() => {
        if (isLoggedIn) {
            const userInfo = LocalStorage.get("solar.userExtraInfo", true);
            if (userInfo?.isRevenda) {
                setDistribuidorRevendaId(userInfo.revenda_id);
            } else if (userInfo?.isDistribuidor) {
                setDistribuidorRevendaId(userInfo.distribuidor_id);
            } else {
                setDistribuidorRevendaId(0);
            }
        }
    }, [isLoggedIn]);

    useEffect(() => {
        const url = window.location.href;
        if (notificacoesUrl[url] && notificacoesUrl[url]?.length > 0) {
            const notificacoesMap = notificacoesUrl[url]?.filter((n) => {
                if (n.elementoAtributos.exibicao === TipoExibicao.EXIBIR_SEMPRE) {
                    return true;
                }

                if (!n.elementoAtributos.visualizado && !visualizadoIds.includes(n.id)) {
                    return true;
                }

                return false;
            }) || [];

            setNotificacoesExbir(notificacoesMap);
        }
    }, [window.location.href, notificacoes]);

    const getStringDate = (date: string) => {
        if (!date) return '';
        return format(new Date(date.replace(' ', 'T')), "dd/MM/yyyy 'às' HH:mm", { locale: ptBR });
    }

    // const confereUrlApresentarPopUp = async (url: string) => {
    //     let popupsUsuariosLocal: PopupsUsuarios[] = [];
    //     if (popupsUsuarios) {
    //         popupsUsuariosLocal.push(...popupsUsuarios)
    //     }
    //     if (notificacoes.length === 1) {
    //         handleOpenDialog(notificacoes[0].elementoAtributos);
    //         //     const response: IDataResponse = await insertPopupConta(notificacoesExibir[0]);
    //     }
    // }

    const marcaPopUpVisualizado = async (notification: NotificacaoElemento): Promise<any> => {
        const form = new FormData();
        form.append('popup_id', notification.id + '');
        const url: string = `cadastros/popups_usuarios/marcar_visualizado`;
        const request: IDataRequest = {
            url: url,
            data: form,
        }
        const ret = await apiNoLoading.post(request)
        setVisualizadoIds([...visualizadoIds, notification.id])
        //setReloadPopups(true);
        return { success: ret.message === 'OK' ? true : false, data: ret.data };
    }

    const getNotifications = useCallback((): ReactNode => {
        return <>{notificacoes.map((_notificacao, index) => {
            return <NotificacaoItem 
                key={`notificacao-item-${index}`}
                visualizado={_notificacao.elementoAtributos.visualizado || visualizadoIds.includes(_notificacao.id)}
                notificacao={_notificacao.elementoAtributos}
                onClick={(_n) => {
                    setNotificacoesExbir([_notificacao]);
                    setAnchorEl(null);
                }}
            />;
        })}</>;
    }, [notificacoes, visualizadoIds])

    return (
        <div>
            {PermissionUtil.can(PermissionUtil.PERMISSION_POPUPS_LISTAGEM, permissoes ? permissoes: []) && (
                <>
                    <Tooltip title={`Popups`} >
                        <IconButton onClick={handleClickPopover} size="large">
                            <Badge badgeContent={notificacoes?.filter(n => !n?.elementoAtributos?.visualizado && !visualizadoIds.includes(n.id) )?.length} color="primary">
                                <NewReleases />
                            </Badge>
                        </IconButton>
                    </Tooltip>

                    <Popover
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClosePopover}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    >
                        <div className='popover-component'>
                            <div className='popover-header' >Pop-ups</div>
                            <Divider />
                            <div className='popover-body' >
                                {getNotifications()}
                            </div>
                        </div>
                    </Popover>
                </>
            )}
            {/* exibe notificações provenientes do click no popup */}
            {/* {notificacao && (
        <DialogNotification
          elementoAtributos={notificacao}
          handleCloseDialog={handleCloseDialog}
          onClose={() => { }}
        />
      )} */}
            {/* exibe notificações provenientes do link acessado em forma de carrossel*/}
            {/* {notificacoesCarrossel && notificacoesCarrossel?.length === 1 && (
        <DialogNotification
          elementoAtributos={notificacoesCarrossel[0].elementoAtributos}
          handleCloseDialog={handleCloseDialog}
          onClose={() => { }}
        />
      )} */}
            {termosPendentes?.length === 0 && !modalCodigoServicoOpen && notificacoesExibir?.length > 0 && (
                <DialogCarrosselNotification
                    openDialogCarrossel={notificacoesExibir?.length > 0}
                    notificacoes={notificacoesExibir}
                    handleCloseDialog={() => {
                        handleCloseCarrosselDialog()
                    }}
                    onVisualizar={(popUpId) => {
                        const notificacaoVisualizada = notificacoesExibir.find(_n => _n.id === popUpId);
                        if (notificacaoVisualizada) {
                            marcaPopUpVisualizado(notificacaoVisualizada)
                        }
                    }}
                />
            )}
        </div>
    );
}

export { Notifications }